import React, { useContext } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";

import "react-perfect-scrollbar/dist/css/styles.css";
import { AddedItemsWrap, EmptyAddedItemsWrap, IncrementButtonWrap } from "../catalogue.styles";
import { EmptyItemIcon } from "../../../../../../AuthenticatedApp/components/productCatalogue/common/images/Icons";
import { NormalText, SemiBoldText } from "../../../../../common/common.styles";
import { ActionTypes, ChargeItemsContext } from "../../../context";
import { formatKoboBalance } from "../../../../../../../utils/utilityFunctions";
import { MinusIcon, PlusIcon } from "../../../../../common/assets/icons/catalogueIcons";

const AddedItems = () => {
    const { state, contextDispatch } = useContext(ChargeItemsContext);

    const handleIncreaseNumber = (id) => {
        contextDispatch({
            type: ActionTypes.INCREASE_NUMBER,
            payload: id,
        });
    };

    const handleDecreaseNumber = (id) => {
        contextDispatch({
            type: ActionTypes.REDUCE_NUMBER,
            payload: id,
        });
    };
    return (
        <PerfectScrollbar style={{ maxHeight: "calc(100% - 350px)", padding: "20px" }}>
            {state.itemsState?.length > 0 ? (
                <>
                    {state.itemsState.map((item, index) => (
                        <AddedItemsWrap key={item + index}>
                            <div className="sales__order-item-wrap">
                                <SemiBoldText>{item.name}</SemiBoldText>
                                <NormalText>{formatKoboBalance(item.currentPrice)}</NormalText>
                            </div>
                            <IncrementButtonWrap>
                                <div
                                    className="sales__order-icon"
                                    onClick={() => handleDecreaseNumber(item.id)}
                                >
                                    <MinusIcon />
                                </div>

                                <NormalText>{item.number}</NormalText>
                                <div
                                    className="sales__order-icon"
                                    onClick={() => handleIncreaseNumber(item.id)}
                                >
                                    <PlusIcon />
                                </div>
                            </IncrementButtonWrap>
                        </AddedItemsWrap>
                    ))}
                </>
            ) : (
                <EmptyAddedItemsWrap>
                    <div className="sales__empty-icon-wrap">
                        <EmptyItemIcon />
                    </div>
                </EmptyAddedItemsWrap>
            )}
        </PerfectScrollbar>
    );
};

export default AddedItems;
